export const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  subTitle: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: '141%',
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },
  tag: {
    border: '1px solid #70737C',
    borderColor: 'rgba(112, 115, 124, 0.2)',
    background: 'transparent',
    color: 'var(--black-color)',
    fontWeight: 400,
    borderRadius: 4,
    padding: '2px 10px',
    display: 'inline-block',
    margin: '0px 4px 4px 0px',
    cursor: 'pointer',
  },
};